import { gql } from '@apollo/client';
import { USER_BASIC_FIELDS, ID_NAME_FIELDS } from 'graphql/common/fragments';

export const SCOOPS_BASIC_RESULTS_DATA_FRAGMENT = gql`
  fragment scoopsBasicResultsData on Scoop {
    id
    text
    userId
    createdAt
    totalScoopComments
    user {
      ${USER_BASIC_FIELDS}
    }
    lastEditedUserId
    lastEditedUser {
      ${USER_BASIC_FIELDS}
    }
    scoopCategories {
      ${ID_NAME_FIELDS}
    }
    companies {
      ${ID_NAME_FIELDS}
      mergedCompanyId
      mergedCompany {
        ${ID_NAME_FIELDS}
      }
    }
  }
`;
